import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Mapper } from '@core/services/mapper';
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { ApiConstant } from '@shared/constants/api.constant';
import { Observable } from 'rxjs';
import { ShipmentHistoryItem } from '@features/shipments/models/shipment-history-item.model';
import { ContractPriceResponse } from '@features/shipment-creation-template/models/contract-price-response';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsCommonApiService {

  constructor(
    private baseAPI: ApiBaseService,
    private mapper: Mapper,
  ) {}
  updateGateToGateTime({id, date}: { id: number, date: Date}): Observable<ShipmentHistoryItem> {
    return this.baseAPI.put(ApiConstant.UPDATE_GATE_TO_GATE_TIME, filterNullEntity({ id, date }))
      .pipe(map((res) => this.mapper.fromJson(ShipmentHistoryItem, res.data)));
  }

  getShipmentHistoryItem(historyItemId: number): Observable<ShipmentHistoryItem> {
    return this.baseAPI.get(ApiConstant.GET_SHIPMENT_HISTORY_ITEM + historyItemId)
      .pipe(map((res) => this.mapper.fromJson(ShipmentHistoryItem, res.data)));
  }

  getTradeLaneContractPrices(payload: {
    fromCityId?: number;
    toCityId?: number;
    customerId?: number;
    fleetId?: number;
    truckTypeId?: number;
  }): Observable<ContractPriceResponse[]> {
    return this.baseAPI
      .get(ApiConstant.GET_TRADE_LANE_PRICES, { params: filterNullEntity(payload) })
      .pipe(map((res) => this.mapper.fromJson(ContractPriceResponse, res.data)));
  }
}
